import { render, staticRenderFns } from "./smi-detail.vue?vue&type=template&id=076c89c4&"
import script from "./smi-detail.vue?vue&type=script&lang=js&"
export * from "./smi-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports